import { render, staticRenderFns } from "./mine-foot-print.vue?vue&type=template&id=213d7cc4&scoped=true&"
import script from "./mine-foot-print.vue?vue&type=script&lang=js&"
export * from "./mine-foot-print.vue?vue&type=script&lang=js&"
import style0 from "./mine-foot-print.vue?vue&type=style&index=0&id=213d7cc4&prod&lang=scss&"
import style1 from "./mine-foot-print.vue?vue&type=style&index=1&id=213d7cc4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213d7cc4",
  null
  
)

export default component.exports